import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import NotificationModal from 'bento-ordering/base/components/NotificationModal';
import PrimaryCta from 'components/Buttons/PrimaryCta';
import SecondaryCta from 'components/Buttons/SecondaryCta';
import { getOwnAlertModalButtonState } from 'styles/helpers/getSecondaryButtonState';

class BetweenMenusNotification extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    handlePrimaryCta: PropTypes.func,
    handleSecondaryCta: PropTypes.func
  };

  render() {
    const { closeModal, handlePrimaryCta, handleSecondaryCta } = this.props;
    return (
      <NotificationModal
        title="Items unavailable at this location"
        body="These menu items are unavailable at the time you selected. Choose a
            different time or view the menu that is available for that time."
        onClose={closeModal}
      >
        <Box
          sx={{
            mt: 2,
            textAlign: 'center'
          }}
        >
          <PrimaryCta
            label="Set A New Time"
            handleClick={handlePrimaryCta}
            fullWidth
          />
        </Box>
        <Box
          sx={{
            mt: 2,
            textAlign: 'center'
          }}
        >
          <SecondaryCta
            ownState={getOwnAlertModalButtonState()}
            label="View Menu"
            handleClick={handleSecondaryCta}
          />
        </Box>
      </NotificationModal>
    );
  }
}

export default BetweenMenusNotification;
